import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={17.314}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 8216 12196"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974618708960">
        <g id="XMLID_2_">
          <path
            d="M3713 7924H1606L0 6319h2108zM3713 8252 2107 9857H0l1606-1605zM3944 8484v2107l-1604 1605v-2107zM5877 10089v2107l-1605-1605V8484zM6612 8252l1604 1605H6110L4503 8252zM8216 6319 6612 7924H4504l1605-1605zM5877 3981v2107L4272 7693V5585zM3944 5585v2108L2340 6088V3981z"
            className="fil0"
          />
        </g>
        <path d="M3952 0h313v5286h-313z" className="fil0" />
      </g>
    </g>
  </svg>
)
export default SvgComponent
